import { apiSlice } from './apiSlice';

const SUBJECTS_URL = '/api/subjects';

export const subjectsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubjects: builder.query({
      query: (departmentId) => ({
        url: SUBJECTS_URL,
        method: 'GET',
        params: departmentId ? { department: departmentId } : undefined
      }),
      transformResponse: (response, meta, arg) => {
        console.log('Subjects API response:', response);
        console.log('Department filter:', arg);
        return response;
      },
      transformErrorResponse: (response, meta, arg) => {
        console.error('Subjects API error:', response);
        console.error('Department filter that caused error:', arg);
        return response;
      },
      providesTags: ['Subject']
    }),
    getSubjectById: builder.query({
      query: (id) => ({
        url: `${SUBJECTS_URL}/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'Subject', id }]
    }),
    createSubject: builder.mutation({
      query: (data) => ({
        url: SUBJECTS_URL,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Subject']
    }),
    updateSubject: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${SUBJECTS_URL}/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Subject', id }]
    }),
    deleteSubject: builder.mutation({
      query: (id) => ({
        url: `${SUBJECTS_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Subject']
    })
  })
});

export const {
  useGetSubjectsQuery,
  useGetSubjectByIdQuery,
  useCreateSubjectMutation,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation
} = subjectsApiSlice; 